export default class GoogleMapsApi {
    static getPlaceSuggestions(input, types) {
        return new Promise((resolve, reject) => {
            try {
                const googleMaps = window.google && window.google.maps;
                if (!googleMaps) {
                    reject('google_maps_not_loaded');
                    return;
                }
                if (input !== '') {
                    const autocompleteService = new googleMaps.places.AutocompleteService();
                    const componentRestrictions = {
                        country: 'US'
                    };
                    const request = {
                        input,
                        componentRestrictions,
                        types
                    };
                    // eslint-disable-next-line sonarjs/no-identical-functions
                    autocompleteService.getPlacePredictions(request, (result, status) => {
                        if (status === 'OK') {
                            resolve(result);
                        }
                        else {
                            reject(`google_maps_${status.toLowerCase()}`);
                        }
                    });
                }
                else {
                    reject('google_maps_invalid_request');
                }
            }
            catch (_a) {
                reject('google_maps_unknown_error');
            }
        });
    }
    static getPlaceDetails(placeId) {
        return new Promise((resolve, reject) => {
            try {
                const googleMaps = window.google && window.google.maps;
                if (!googleMaps) {
                    reject('google_maps_not_loaded');
                    return;
                }
                if (placeId !== '') {
                    const container = document.createElement('div');
                    const placesService = new googleMaps.places.PlacesService(container);
                    const request = {
                        placeId,
                        fields: ['place_id', 'address_component', 'formatted_address', 'name']
                    };
                    // eslint-disable-next-line sonarjs/no-identical-functions
                    placesService.getDetails(request, (result, status) => {
                        if (status === 'OK') {
                            resolve(result);
                        }
                        else {
                            reject(`google_maps_${status.toLowerCase()}`);
                        }
                    });
                }
                else {
                    reject('google_maps_invalid_request');
                }
            }
            catch (_a) {
                reject('google_maps_unknown_error');
            }
        });
    }
}
//# sourceMappingURL=index.js.map